var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVueJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 106.42",
    style: {
      enableBackground: "new 0 0 122.88 106.42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#4DBA87;} .st1{fill:#425466;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.63,0 61.44,24.58 47.25,0 0,0 61.44,106.42 122.88,0 75.63,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.63,0 61.44,24.58 47.25,0 24.58,0 61.44,63.85 98.3,0 75.63,0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVueJs);
export default __webpack_public_path__ + "static/media/icon_vue_js.9f537ef871539b63299dea9ec24182f4.svg";
export { ForwardRef as ReactComponent };